import { render, staticRenderFns } from "./PreformattedTextView.vue?vue&type=template&id=69974b9b&scoped=true&"
import script from "./PreformattedTextView.vue?vue&type=script&lang=js&"
export * from "./PreformattedTextView.vue?vue&type=script&lang=js&"
import style0 from "./PreformattedTextView.vue?vue&type=style&index=0&id=69974b9b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69974b9b",
  null
  
)

export default component.exports